module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-Medium-ef50bf35f04eb35ad8dd51cadb5fc0d4.svg";